import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

/**
 * @deprecated Legacy icon.
 * */
function QuoteClosedIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 22">
      <path fill="currentColor" d="M14.151 17.93v3.948c2.66-.336 4.815-1.624 6.467-3.863 1.652-2.24 2.478-5.431 2.478-9.575V0H14.15v9.154h4.578c.028.336.049.553.063.651.014.098.02.217.02.357 0 1.176-.195 2.366-.587 3.57-.784 2.435-2.142 3.835-4.074 4.199zM0 17.93v3.948c3.191-.392 5.487-1.897 6.887-4.514 1.4-2.618 2.1-5.592 2.1-8.924V0H0v9.154h4.577c.056.196.091.378.105.546.014.168.021.336.021.504 0 1.932-.399 3.64-1.197 5.123C2.708 16.811 1.54 17.68 0 17.931z"/>
    </SvgIcon>
  )
}
export default QuoteClosedIcon
